import axios from "axios";
import store from "@/store";

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_STORMPORT_API_URL}/${process.env.VUE_APP_STORMPORT_API_VER}`,
  headers: { "X-Requested-With": "XMLHttpRequest" },
  responseType: "json",
});

instance.interceptors.request.use(
  (config) => {
    const token = store.state.auth.token;
    const legacy_key = process.env.VUE_APP_STORMPORT_API_KEY;

    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    if (legacy_key) {
      config.params = {
        ...config.params,
        key: legacy_key
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    switch (error.response.status) {
      case 422:
        let errors = error.response.data.errors;

        errors = Object.keys(errors).reduce((acc, key) => {
          let error = errors[key];

          if (!Array.isArray(error)) error = [error];

          return acc.concat(error);
        }, []);

        if (errors.length) {
          store.commit("snacktime", {
            text: errors.join("<br />"),
            color: "error",
          });
        }

        break;
      case 500:
        store.commit("snacktime", {
          text: error.response.data.message,
          color: "error",
        });

        break;
    }

    return Promise.reject(error);
  }
);

export default instance;
